export default "__VITE_ASSET__8a77635b__"